import React from "react"
import _ from "lodash"
import { MessageBubble } from "../util"

import "./Contacts.scss"


const Contacts = ({ data, isUser = false, color }) => {
  const { name, org } = _.get(data, "contact", {})
  const addresses = _.get(data, "contact.addresses", [])
  const emails = _.get(data, "contact.emails", [])
  const ims = _.get(data, "contact.ims", [])
  const phones = _.get(data, "contact.phones", [])
  const urls = _.get(data, "contact.urls", [])

  const handleArrayData = () => {
    return (
      <div>
        {addresses.length > 0 && (
          <>
            <h4>Addresses: </h4>
            {addresses.map((address, i) => (
              <p>{i + 1}. {address.street}</p>
            ))} 
          </>        
        )}
        {emails.length > 0 && (
          <>
            <h4>Email: </h4>
            {emails.map((email, i) => (
              <p>{i + 1}. {email.email}</p>
            ))}
          </>
        )}
        {ims.length > 0 && (
          <>
            <h4>Ims: </h4>
            {ims.map((im, i) => (
              <p>{i + 1}. {im.im}</p>
            ))}
          </>
        )}
        {urls.length > 0 && (
          <>
            <h4>Urls: </h4>
            {urls.map((url, i) => (
              <p>{i + 1}. {url.url}</p>
            ))}
          </>
        )}
        {phones.length > 0 && (
          <>
            <h4>Phone: </h4>
            {phones.map((phone, i) => (
              <p>{i + 1}. {phone.phone}</p>
            ))}
          </>
        )}     
      </div>         
    )
  }

  return (
    <MessageBubble>
      <div>
        <h4>Name: </h4>
        {_.get(name, "formatted_name", "")}
      </div>
      <div>
        <h4>Company: </h4>
        {_.get(org, "company", "")}
      </div>
      {handleArrayData()}
    </MessageBubble>
  )
}

export default Contacts
